export const login_url: string = "auth/login";
export const profile_url: string = "profile";
export const change_password_url: string = "change_password";
export const reset_password_url: string = "password_reset";
